{
    "LEGEND_DESCRIPTION": "Legend operating status"
}
